import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardTitle, Col, Form, Input, Label, Row } from 'reactstrap'
import { PropTypes } from 'prop-types';
import { useHistory, withRouter } from 'react-router-dom';
import * as currencyApi from '../../apis/currencyApi';
import { getMessage } from './../../Utils/ErrMessageUtils';

function Currency(props) {
    const code = props.match.params?.code;
    const [data, setData] = useState({})
    let history = useHistory();
    useEffect(() => {
        if (code) {
            fetchData(code);
        }
    }, [props.match.params])
    const fetchData = (code) => {
        currencyApi.get(code, fetchDataSuccess, fetchDataFail)
    }
    const fetchDataSuccess = (res) => {
        setData(res.data.data)
    }
    const fetchDataFail = (res) => {
        alert(getMessage(res.message))
    }
    const onChangeData = (value, attrName) => {
        data[attrName] = value;
        setData({ ...data })
    }
    const onSubmit = (e) => {
        e.preventDefault();
        if (code) {
            currencyApi.update(code, data, onSubmitSuccess, onSubmitFail)
        }
        else {
            currencyApi.create(data, onSubmitSuccess, onSubmitFail)
        }
    }
    const onSubmitSuccess = (res) => {
        history.push("/currencies")
    }
    const onSubmitFail = (res) => {
        alert(getMessage(res.message))
    }
    return (
        <div className="page-content">
            <Card>
                <CardBody>
                    <CardTitle className="mb-4">Danh mục đơn vị tiền tệ</CardTitle>
                    <Form onSubmit={onSubmit}>
                        <div className="mb-3">
                            <Label htmlFor="Shop-code-input">Mã đơn vị tiền tệ</Label>
                            <Input
                                type="text"
                                className="form-control"
                                id="currency-code-input"
                                placeholder="Nhập mã đơn vị tiền tệ"
                                value={data.currency_code}
                                onChange={e => onChangeData(e.target.value, 'currency_code')}
                                disabled={code ? true : false}
                            />
                        </div>
                        <div className="mb-3">
                            <Label htmlFor="Shop-name-Input">Tên đơn vị tiền tệ</Label>
                            <Input
                                type="text"
                                className="form-control"
                                id="currency-name-input"
                                placeholder="Nhập tên đơn vị tiền tệ"
                                value={data.currency_name}
                                onChange={e => onChangeData(e.target.value, 'currency_name')}
                            />
                        </div>
                        <div>
                            <button type="submit" className="btn btn-primary w-md">
                                Lưu
                            </button>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </div>
    )
}
Currency.propTypes = {
    location: PropTypes.object,
    match: PropTypes.object,
}


export default withRouter(Currency);
